import axios from "axios";

import * as fb from "@/firebase/index.js";
export default {
  state: {
    hearingInfo: [],
    lastFetched: null,
    intervalTimer: 300000,
    selectedHearing: null,
  },
  getters: {
    hearingInfo: (state) => state.hearingInfo,
    lastFetched: (state) => state.lastFetched,
    intervalTimer: (state) => state.intervalTimer,
    getSelectedHearing: (state) => state.selectedHearing,
  },
  mutations: {
    setHearingInfo(state, hearingObj) {
      state.hearingInfo = hearingObj;
    },
    emptyHearingInfo(state) {
      state.hearingInfo = [];
    },
    setLastFetched(state, fetchObj) {
      state.lastFetched = fetchObj;
    },
    setIntervalTimer(state, timer) {
      state.intervalTimer = timer;
    },
    setSelectedHearing(state, hearing) {
      state.selectedHearing = hearing;
    },
  },
  actions: {
    fetchDocketInformation({ commit, getters }) {
      let data = JSON.stringify({
        userName: "lasalle",
        filePath: "/",
        apiKey:
          "ars-bb-E4uOcpcLgEIKXd-pY5x9Z-bo!7Wl-mLuQCRTmvhqzi4kYpizFdV!tdJizI?Yb75HVSlpw74t-IodAkfSW3qNk7e2OZ8Vwa-ffojXZ2oWrP-AmV0y1z3?SJKmL",
      });
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://us-central1-midwest-usa-20eac.cloudfunctions.net/fetchdocketlasalle/docketInformation",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          const map = {};
          let num = 0;
          response.data.forEach((item) => {
            num = num + 1;
            if (!map[item.partyName]) {
              map[item.partyName] = {
                partyName: item.partyName,
                date: item.date,
                hearings: [],
                count: 0,
                id: num,
                caseNumber: item.caseNumber,
              };
            }
            map[item.partyName].hearings.push({
              hearingLocation: item.hearingLocation,
              caseNumber: item.caseNumber,
              time: item.time,
            });
            map[item.partyName].count++;
          });
          commit("setHearingInfo", Object.values(map));
          fb.kioskCollection.doc(getters.getKioskId).update({
            pullFiles: false,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
